export default "__VITE_ASSET__B2h5aH_Y__"